import api from './client';

// Player Portal API (player role only — endpoints resolve player from JWT)
export const playerPortalAPI = {
  getDashboard: async () => {
    const response = await api.get('/player/dashboard');
    return response.data;
  },
  getProfile: async () => {
    const response = await api.get('/player/profile');
    return response.data;
  },
  getMedical: async () => {
    const response = await api.get('/player/medical');
    return response.data;
  },
  getMedicalReports: async () => {
    const response = await api.get('/player/medical/reports');
    return response.data;
  },
  viewMedicalAttachment: async (id: string): Promise<Blob> => {
    const response = await api.get(`/player/medical/reports/attachments/${id}/view`, {
      responseType: 'blob',
    });
    return response.data;
  },
};
